export default class DepositRequest {
    constructor(payerData, paymentDetail, deposit_detail) {
      this.payer_data = payerData;
      this.payment_detail = paymentDetail;
      this.deposit_detail = deposit_detail;
    }
  }